"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { Patch } from "@/shared/libs/axios/request";
import { orderKeys } from "@/entities/order";
import type {
  PurchaseOrderResponse,
  UpdatePurchaseOrderRequest,
} from "@stocks/shared";

export const useUpdateOrder = (id: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (values: UpdatePurchaseOrderRequest) =>
      Patch<PurchaseOrderResponse, UpdatePurchaseOrderRequest>(
        `/v1/purchase-orders/${id}`,
        values,
      ),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: [orderKeys.orders] });
      toast.success(res.data.message);
    },
    onError: (error) =>
      toast.error(error.response?.data.message ?? "발주 수정에 실패했습니다."),
  });
};
